import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

import {
  useAuditLogEventClassNames,
  useAuditLogEventName,
  useAuditLogMetadata,
} from "@ryde/redux";
import {
  getAuditLogCauserDisplayName,
  getEventEmoji,
  IAuditLogDto,
  useFormats,
} from "@ryde/shared";

import { AuditLogMetadataLabels } from "./audit-log-metadata-labels";
import { EntityHeaderStyled } from "./entity-header.styled";

interface IEntityHeaderProps {
  entityItemData: IAuditLogDto;
}

export const EntityHeader = ({
  entityItemData,
}: IEntityHeaderProps): ReactElement => {
  const { t } = useTranslation();
  const { formatDateTimeWithSecondsNormalized } = useFormats();

  const { getEventName } = useAuditLogEventName();
  const { getMetadataText } = useAuditLogMetadata();
  const { getEventClassNames } = useAuditLogEventClassNames();

  const eventName = getEventName(entityItemData.eventName);
  const metadataText = getMetadataText({
    metadata: entityItemData.metadata,
    eventName: entityItemData.eventName,
    entity: entityItemData.entity,
  });
  const metadataClassNames = getEventClassNames({
    baseClassName: "EntityHeader-Metadata",
    eventName: entityItemData.eventName,
    metadata: entityItemData.metadata,
  });

  return (
    <EntityHeaderStyled>
      <data className="EntityHeader-Item">
        {t("auditLog.formatLog", {
          eventName,
          userInfo: getAuditLogCauserDisplayName(entityItemData, t),
          dateTime: formatDateTimeWithSecondsNormalized(
            entityItemData.createdAt,
          ),
        })}
        <span className="EntityHeader-Emoji">
          {getEventEmoji(entityItemData.eventName)}
        </span>
        <AuditLogMetadataLabels
          metadataText={metadataText}
          metadataClassNames={metadataClassNames}
          metadata={entityItemData.metadata}
          metadataBadgeClassName="EntityHeader-Metadata"
        />
      </data>
    </EntityHeaderStyled>
  );
};
